import { useAppSelector } from '@common/hooks'
import prepareAppDate from '@common/utils/prepareAppDate'
import type { IAppReview } from '@redux/slices/applicationRating/applicationRating.types'
import cx from 'classnames'
import type { ReactNode } from 'react'

import StarsRow from '../StarsRow'
import classNames from './styles.module.scss'


interface IProps {
  children?: ReactNode,
  className?: string,
}

Review.defaultProps = {
  children: null,
  className: undefined,
}

export default function Review({ children, className, ...rest }: IAppReview & IProps): JSX.Element {
  const {
    userName,
    body,
    score,
    title,
    updated,
    userId,
  } = rest
  const currentUserId = useAppSelector(store => store.common.data.config?.token.user_id)
  return (
    <div data-test="app-review" className={cx(classNames.wrapper, currentUserId && currentUserId === userId && classNames.myReview, className)}>
      <h4 className={classNames.author} data-test="review-author">
        <span className={classNames.userName}>{userName}</span>
        <div className={classNames.leftNav}>
          {!(currentUserId && currentUserId === userId) && children}
          <span data-test="review-date" className={classNames.date}>{prepareAppDate(updated)}</span>
        </div>
      </h4>
      <div className={classNames.appInfo}>
        <StarsRow value={score} className={classNames.stars}/>
        <h5 className={classNames.title} data-test="review title">{title}</h5>
      </div>
      <p className={classNames.body} data-test="review-description">{body}</p>
    </div>
  )
}
